import PageShell from "../components/common/PageShell";
import useChickenHistory from "../hooks/useChickenHistory";
import { dt } from "../utils/format";

// GET /chicken/history se real results
const TAG = { cashed: "w", burnt: "l", refunded: "n", active: "n" };

const label = (r) =>
  r.outcome === "cashed"
    ? `Cashed ${r.multiplier.toFixed(2)}x`
    : { burnt: "Burnt", refunded: "Refunded", active: "Active" }[r.outcome];

export default function Results() {
  const { rows, loading, error, reload } = useChickenHistory();
  const last = rows.find(
    (r) => r.outcome === "cashed" || r.outcome === "burnt",
  );

  return (
    <PageShell title="Results">
      {last && (
        <section className="pg-card pg-latest">
          <div className={`cr-badge ${last.outcome}`}>
            {last.outcome === "cashed"
              ? `${last.multiplier.toFixed(2)}x`
              : "🔥"}
          </div>
          <div>
            <h2 style={{ margin: 0 }}>Last round</h2>
            <span className="pg-muted">
              {last.difficulty},{" "}
              {last.outcome === "cashed" ? "cashed out" : "burnt"} on step{" "}
              {last.steps}, {dt(last.createdAt)}
            </span>
          </div>
        </section>
      )}

      <section className="pg-card">
        <h2>All results</h2>
        {loading ? (
          <p className="pg-empty">Loading...</p>
        ) : error ? (
          <p className="pg-empty">
            {error}{" "}
            <button className="pg-tab" onClick={reload}>
              Retry
            </button>
          </p>
        ) : rows.length === 0 ? (
          <p className="pg-empty">No rounds yet.</p>
        ) : (
          <table className="pg-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Round</th>
                <th>Difficulty</th>
                <th>Steps</th>
                <th>Outcome</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id}>
                  <td data-l="#">{i + 1}</td>
                  <td data-l="Round">{r.id.slice(-8)}</td>
                  <td data-l="Difficulty">
                    <span className={`pg-diff ${r.difficulty.toLowerCase()}`}>
                      {r.difficulty}
                    </span>
                  </td>
                  <td data-l="Steps">{r.steps}</td>
                  <td data-l="Outcome">
                    <span className={`pg-tag ${TAG[r.outcome]}`}>
                      {label(r)}
                    </span>
                  </td>
                  <td data-l="Time">{dt(r.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </PageShell>
  );
}
